// src/features/dashboard/routes.ts
import { Route } from '@tanstack/react-router';
import { rootRoute } from '../../app/routing/rootRoute';
import DashboardHomePage from './pages/DashboardHomePage';
import { useAuthStore } from '../auth/store/authStore';
import { redirect } from '@tanstack/react-router';

// Dashboard route
export const dashboardRoute = new Route({
  getParentRoute: () => rootRoute,
  path: 'dashboard',
  component: DashboardHomePage,
  beforeLoad: () => {
    const isAuthenticated = useAuthStore.getState().isAuthenticated();
    if (!isAuthenticated) {
      throw redirect({ to: '/auth/login' });
    }
  },
});

export const dashboardRoutes = [dashboardRoute];
